export function getScrollContainer(): {
  container: Element | Window;
  scrollY: number;
} {
  const rmdv2Wrapper = document.querySelector("#rmd-v2-wrapper");
  if (rmdv2Wrapper && window.innerWidth >= 1280) {
    return { container: rmdv2Wrapper, scrollY: rmdv2Wrapper.scrollTop };
  }
  return { container: window, scrollY: window.scrollY };
}

export function scrollToPos({
  top,
  left = 0,
  behavior = "smooth",
}: {
  top: number;
  left?: number;
  behavior?: "instant" | "smooth";
}) {
  requestAnimationFrame(() => {
    const { container } = getScrollContainer();

    container.scrollTo({
      top,
      left,
      behavior,
    });
  });
}

export function scrollToElement({
  selector,
  offset = 0,
  behavior = "smooth",
}: {
  selector: string;
  offset?: number;
  behavior?: "instant" | "smooth";
}) {
  requestAnimationFrame(() => {
    const element = document.querySelector(selector) as HTMLElement;
    if (!element) {
      return;
    }

    const { container, scrollY } = getScrollContainer();
    const rect = element.getBoundingClientRect();
    const top = rect.top + scrollY + offset - 60;

    container.scrollTo({
      top,
      left: 0,
      behavior,
    });
  });
}

export function centerElementInScroll({
  selector,
  behavior = "smooth",
  offset = 0,
}: {
  selector: string;
  behavior?: "instant" | "smooth";
  offset?: number;
}) {
  requestAnimationFrame(() => {
    const element = document.querySelector(selector) as HTMLElement;
    if (!element) {
      return;
    }

    const { container, scrollY } = getScrollContainer();
    const rect = element.getBoundingClientRect();

    // Get container height
    const containerHeight =
      container === window
        ? window.innerHeight
        : (container as Element).clientHeight;

    // Calculate scroll position to center the element on screen
    const top =
      offset + rect.top + scrollY - containerHeight / 2 + rect.height / 2;

    container.scrollTo({
      top,
      left: 0,
      behavior,
    });
  });
}

export function scrollToElementAdaptive({
  selector,
  offset = 0,
  behavior = "smooth",
}: {
  selector: string;
  offset?: number;
  behavior?: "instant" | "smooth";
}) {
  requestAnimationFrame(() => {
    const element = document.querySelector(selector) as HTMLElement;
    if (!element) {
      return;
    }

    const { container, scrollY } = getScrollContainer();
    const rect = element.getBoundingClientRect();

    const containerHeight =
      container === window
        ? window.innerHeight
        : (container as Element).clientHeight;

    let top: number;

    if (rect.height >= containerHeight - 300) {
      // Element is taller than viewport — scroll to its start
      top = rect.top + scrollY + offset * 1.5;
    } else {
      // Element is shorter than viewport — place its start at 1/3 of the element
      top = rect.top + scrollY + offset - containerHeight / 3;
    }

    container.scrollTo({
      top,
      left: 0,
      behavior,
    });
  });
}

export function scrollToStart() {
  scrollToPos({ top: 0, behavior: "smooth" });
}
